import { useQuery } from '@tanstack/react-query';
import {
  SignalStage,
  type SignalStageType,
} from '@terra/shared-schemas-orchestrator';
import { terraProxyApiClient } from '../../clients/testerClient';

export type SignalsStageCounts = {
  total: number;
  blocked: number;
  byStage: Record<SignalStageType, number>;
};

export function useSignalsStageCounts(applicationId: string) {
  return useQuery({
    queryKey: ['signals-stage-counts', applicationId],
    queryFn: async (): Promise<SignalsStageCounts> => {
      const result =
        await terraProxyApiClient.getSignalsCountByApplicationId(applicationId);

      return {
        total: result?.total ?? 0,
        blocked: result?.statusCounts?.BLOCKED ?? 0,
        byStage: {
          [SignalStage.NEW]: result?.counts?.NEW ?? 0,
          [SignalStage.IN_TESTING]: result?.counts?.IN_TESTING ?? 0,
          [SignalStage.NEEDS_REVIEW]: result?.counts?.NEEDS_REVIEW ?? 0,
          [SignalStage.TESTED]: result?.counts?.TESTED ?? 0,
        },
      };
    },
    enabled: !!applicationId,
    staleTime: 30_000,
  });
}
